import { Centered } from '../centered'

export function NoResultsFound() {
  return (
    <Centered className="flex w-full flex-col py-2 text-center text-2xs font-medium">
      <span>No results in tickers or company names</span>
      <span className="text-muted-2">Try again with different keywords.</span>
    </Centered>
  )
}
